export enum ETipoTesteQuestaoIncidental {
  Substantivo = 1,
  Controle = 2
}

export const ETipoTesteQuestaoIncidentalDescricao = {
  [ETipoTesteQuestaoIncidental.Substantivo]: 'Substantivo',
  [ETipoTesteQuestaoIncidental.Controle]: 'Controle'
};